import { render, staticRenderFns } from "./people.vue?vue&type=template&id=42105d00&scoped=true"
import script from "./people.vue?vue&type=script&lang=js"
export * from "./people.vue?vue&type=script&lang=js"
import style0 from "./people.vue?vue&type=style&index=0&id=42105d00&prod&lang=scss&scoped=true"
import style1 from "./people.vue?vue&type=style&index=1&id=42105d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42105d00",
  null
  
)

export default component.exports